import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards';

export const stadiumsRoutes: Routes = [
  {
    path: 'stadiums',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/list/stadium-list.component').then((m) => m.StadiumListComponent),
      },
      {
        path: 'create',
        redirectTo: 'new',
        pathMatch: 'full',
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/create/stadium-create.component').then(
            (m) => m.StadiumCreateComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./components/detail/stadium-detail.component').then(
            (m) => m.StadiumDetailComponent
          ),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/edit/stadium-edit.component').then((m) => m.StadiumEditComponent),
        canActivate: [authGuard],
      },
    ],
  },
];
